import { createStore } from 'vuex';
import filters from './modules/filters';
import map from './modules/map';
import charts from './modules/charts';
import nav from './modules/nav';

const debug = (import.meta.env.MODE !== 'production');

export default createStore({
  strict: debug,

  modules: {
    filters,
    map,
    charts,
    nav,
  },
});
